import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

// Dynamically use the cloud backend URL if deployed, otherwise fallback to local
const baseURL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to inject Bearer token
api.interceptors.request.use(async (config) => {
  let token = null;
  if (Capacitor.isNativePlatform()) {
    try {
      const { value } = await SecureStoragePlugin.get({ key: 'thread_token' });
      token = value;
    } catch (e) {
      // Key not found in secure storage
    }
  } else {
    token = localStorage.getItem('thread_token');
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add a response interceptor to handle 401 Unauthorized errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('thread_user');
      window.dispatchEvent(new Event('thread_auth_error'));
    }
    return Promise.reject(error);
  }
);

export default api;
